import React, { Component } from 'react'
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core/'
import { homeActions } from '../actions/home.actions'
import { withStyles } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core/'
import { styles } from '../containers/dockPadStyle'
import { compose } from 'redux'
import { connect } from 'react-redux'

class CreateSampleProjectDialog extends Component {
  handleCreate = () => {
    const {
      createSampleProject,
      isLoadingAct
    } = homeActions

    const { dispatch } = this.props
    dispatch(isLoadingAct())
    dispatch(createSampleProject())
  }

  renderDialog = () => {
    const { isLoading } = this.props
    return (
      <Dialog
        open={this.props.isCreateSampleProjectDialogOpen}
        onClose={this.handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'>
        {!isLoading ? (
          <React.Fragment>
            <DialogTitle id='alert-dialog-title'>
              {'Would you like to create a sample project?'}
            </DialogTitle>

            <DialogActions>
              <Button onClick={this.handleClose} color='primary'>
                No
              </Button>
              <Button onClick={this.handleCreate} color='primary' autoFocus>
                Yes
              </Button>
            </DialogActions>
          </React.Fragment>
        ) : (
          this.renderProgress()
        )}
      </Dialog>
    )
  }
  renderProgress = () => {
    const { classes } = this.props

    return (
      <div
        style={{
          padding: '32px',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex'
        }}>
        <CircularProgress className={classes.circleProgress} />
      </div>
    )
  }

  handleClose = () => {
    const { dispatch } = this.props
    dispatch(homeActions.closeCreateSampleProjectDialog())
  }

  render() {
    return <div> {this.renderDialog()} </div>
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect((state, props) => {
    return {
      isLoading: state.homeView.isLoading,
      isCreateSampleProjectDialogOpen: state.homeView.isCreateSampleProjectDialogOpen
    }
  })
)(CreateSampleProjectDialog)



// WEBPACK FOOTER //
// ./src/components/SampleProject.tsx